var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53553 7.05024C9.92607 6.6597 10.5592 6.65975 10.9497 7.05024C11.3402 7.44074 11.3403 8.07392 10.9497 8.46446L8.41417 11H18C18.5523 11 19 11.4477 19 12C19 12.5523 18.5523 13 18 13H8.41425L10.9497 15.5355C11.3402 15.926 11.3403 16.5592 10.9497 16.9497C10.5592 17.3403 9.92603 17.3402 9.53553 16.9497L5.29789 12.7121C5.28076 12.6952 5.26423 12.6777 5.24835 12.6596C5.17852 12.5802 5.12341 12.4923 5.08303 12.3996C5.02962 12.2772 5 12.1421 5 12C5 11.872 5.02407 11.7496 5.06793 11.637C5.11667 11.5116 5.19166 11.3941 5.29289 11.2929L9.53553 7.05024Z",
    fill: "#20E290"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.332a40dd0d5662e503d2aa592066ac5b.svg";
export { ForwardRef as ReactComponent };